import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, ChevronDown } from "lucide-react";
import { SERVICES } from "../data/services";
import { PlatformsNav, PlatformsMobileNav } from "./PlatformsNav";

const nav = [
  { to: "/publications", label: "Publications" },
  { to: "/about", label: "About" },
  { to: "/academy", label: "Academy" },
  { to: "/contact", label: "Contact" },
];

export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const linkCls = ({ isActive }) => `px-3 py-2 text-sm font-semibold transition-colors duration-200 ${isActive ? "text-[var(--teal)]" : "text-slate-700 hover:text-[var(--teal)]"}`;

  return (
    <header data-testid="site-header" className="sticky top-0 z-50 border-b border-slate-200/80 bg-white/85 backdrop-blur-md">
      <div className="mx-auto flex h-[104px] max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3">
          <img src="/logo.png" alt="MarksMan Healthcare — Evidence. Insights. Access." className="h-[72px] w-auto sm:h-[88px]" />
        </Link>
        <nav className="hidden items-center gap-1 lg:flex">
          <div className="group relative">
            <button data-testid="nav-services" className={`flex items-center gap-1 px-3 py-2 text-sm font-semibold transition-colors duration-200 ${pathname.startsWith("/services") ? "text-[var(--teal)]" : "text-slate-700 hover:text-[var(--teal)]"}`}>
              Capabilities <ChevronDown size={14} className="transition-transform duration-200 group-hover:rotate-180" />
            </button>
            <div className="invisible absolute left-0 top-full w-[640px] translate-y-1 pt-3 opacity-0 transition-[opacity,transform,visibility] duration-200 group-hover:visible group-hover:translate-y-0 group-hover:opacity-100">
              <div className="grid grid-cols-2 gap-1 rounded-xl border border-slate-200 bg-white p-3 shadow-xl">
                {SERVICES.map((s) => (
                  <Link key={s.slug} to={`/services/${s.slug}`} data-testid={`nav-service-${s.slug}`} className="rounded-lg p-3 transition-colors duration-150 hover:bg-[var(--surface)]">
                    <div className="text-sm font-semibold text-[var(--navy)]">{s.name}</div>
                    <div className="mt-0.5 text-xs text-slate-500">{s.short}</div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
          <PlatformsNav />
          {nav.map((n) => (
            <NavLink key={n.to} to={n.to} data-testid={`nav-${n.label.toLowerCase()}`} className={linkCls}>{n.label}</NavLink>
          ))}
          <Link to="/contact" data-testid="nav-cta" className="btn-primary ml-3 !py-2.5">Talk to a consultant</Link>
        </nav>
        <button data-testid="nav-mobile-toggle" onClick={() => setOpen(!open)} className="rounded-md p-2 text-slate-700 lg:hidden" aria-label="Menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div data-testid="nav-mobile-menu" className="border-t border-slate-200 bg-white px-4 py-4 lg:hidden">
          <div className="eyebrow mb-2">Capabilities</div>
          {SERVICES.map((s) => (
            <Link key={s.slug} to={`/services/${s.slug}`} onClick={() => setOpen(false)} className="block py-2 text-sm font-medium text-slate-700">{s.name}</Link>
          ))}
          <div className="my-3 border-t border-slate-100" />
          <PlatformsMobileNav onNavigate={() => setOpen(false)} />
          {nav.map((n) => (
            <Link key={n.to} to={n.to} onClick={() => setOpen(false)} className="block py-2 text-sm font-semibold text-slate-800">{n.label}</Link>
          ))}
        </div>
      )}
    </header>
  );
}
